import React, {lazy, Suspense, useEffect, useState} from "react";
import "./App.css";
import "./nicepage.css";
import {Route, Switch, useHistory} from "react-router-dom";
import {getCurrentUser, isAuthenticateValid} from "../util/APIUtils";
import {ACCESS_TOKEN} from "../constants";
import NotFound from "../component/NotFound/";
import LoadingIndicator from "../component/LoadingIndicator/";
import {Col, Layout, notification, Spin} from "antd";
import UnderDevelopment from "../component/UnderDevelopment/";
import {dataContext} from "../context";
import HomePage from "../page/HomePage/";
import Header from "../component/Header/";
import CampaignTable from "../component/Table/CampaignTable";
import Campaigns from "../page/campaigns";
import ContactUs from "../page/contactUs";
import EczaciKimlikKart from "../page/eczaciKimlikKart/";
import CampaignDetail from "../page/campaignDetail";
import SignUp from "../page/signUp";
import ForgotPassword from "../page/forgotPassword/forgotPassword";
import ResetPassword from "../page/forgotPassword/ResetPassword";
import {showAxiosError} from "../util/Helpers";
import AdminPageHeader from "../component/admin/header/header";
import PharmacyCardTable from "../component/Table/PharmacyCard";
import HomePageCampaignImage from "../page/homePageCampaignImage/HomePageCampaignImage";
import FuelCampaignTablePage from "../page/fuelCampaignTablePage";
import UserOperationsPage from "../page/userOperationsPage";
import UserTable from "../component/Table/UserTable";
import UserList from "../component/Table/UserList";
import AllUserTable from "../component/Table/AllUserTable";
import UnderConstructionPage from "../page/UnderConstructionPage";



// const Profile = lazy(() => import("../page/profile/"));
const Login = lazy(() => import("../page/login/"));
const {Content} = Layout;

function App() {
    const [currentUser, setCurrentUser] = useState(null);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isAdminPanelOpen, setIsAdminPanelOpen] = useState(false);

    const data = {
        currentUser,
        setCurrentUser,
        isAuthenticated,
        setIsAuthenticated,
        isLoading,
        setIsLoading,
        isAdminPanelOpen,
        setIsAdminPanelOpen,
    };

    let history = useHistory();

    useEffect(() => {
        if (!checkRouter()) {
            //loadCurrentUser();
            setIsLoading(false);
        } else {
            setIsLoading(false);
        }
    }, []);

    function handleLogout() {
        localStorage.removeItem(ACCESS_TOKEN);
        setCurrentUser(null);
        setIsAuthenticated(false);

        history.push("/");
        notification["success"]({
            message: "Bilgilendirme",
            description: "Başarılı şekilde çıkış yaptınız",
        });
    }

    function handleLogin() {
        notification.success({
            message: "Başarılı",
            description: "Başarıyla giriş yaptınız.",
        });
        loadCurrentUser();
        history.push("/");
    }

    function checkRouter() {
        let result = false;
        const checkList = ["/resetPassword"];
        checkList.forEach((element) => {
            if (window.location.href.includes(element)) result = true;
        });
        return result;
    }

    function loadCurrentUser() {
        if (isAuthenticateValid()) {
            setIsLoading(true);

            getCurrentUser()
                .then((response) => {
                    setCurrentUser(response.data);
                    setIsAuthenticated(true);
                    setIsLoading(false);
                })
                .catch((error) => {
                    showAxiosError(error.response)
                    setIsLoading(false);
                    history.push("/login");
                });
        } else {
            history.push("/login");
            setIsLoading(false);
        }
    }

    return isLoading === true ? (
        <LoadingIndicator/>
    ) : (
        <dataContext.Provider value={data}>
            <Layout className="app-container u-body u-xl-mode">
                {(currentUser && isAdminPanelOpen) ? (<AdminPageHeader/>) : null}
                {(currentUser && !isAdminPanelOpen) ? (<Header onLogout={handleLogout}/>) : null}
                <Content className="app-content">
                    <div className="container">
                        <Suspense
                            fallback={
                                <Col span={24} style={{paddingTop: 160, textAlign: "center"}}>
                                    <Spin size="large"/>
                                </Col>
                            }
                        >
                            <Switch>
                                <Route exact path="/">
                                    <UnderConstructionPage/>
                                </Route>
                                <Route exact path="/home">
                                    <HomePage/>
                                </Route>
                                <Route path="/login-old">
                                    <Login onLogin={handleLogin}/>
                                </Route>
                                <Route path="/Kayit-Ol">
                                    <SignUp/>
                                </Route>
                                <Route path="/kampanyalarıDüzenle">
                                    <CampaignTable/>
                                </Route>
                                <Route path="/eczacı-kart">
                                    <PharmacyCardTable/>
                                </Route>
                                <Route path="/user">
                                     <UserTable/>
                                </Route>
                                  <Route path="/userList">
                                     <UserList/>
                                 </Route>
                                 <Route path="/eczacı-kart-kullanicilar">
                                      <AllUserTable/>
                                 </Route>

                                <Route path="/anaSayfaKampanyaFotografı">
                                    <HomePageCampaignImage/>
                                </Route>
                                <Route path="/sifremi-unuttum">
                                    <ForgotPassword/>
                                </Route>
                                <Route path="/resetPassword">
                                    <ResetPassword/>
                                </Route>
                                <Route path="/Kampanyalar">
                                    <Campaigns/>
                                </Route>
                                <Route path="/user">
                                    <FuelCampaignTablePage/>
                                </Route>
                                <Route path="/eczacı-kart deneme">
                                    <UserOperationsPage/>
                                </Route>
                                <Route path="/Bize-Ulaşın">
                                    <ContactUs/>
                                </Route>
                                <Route path="/Kimlik-Kart-Talep-Et">
                                    <EczaciKimlikKart/>
                                </Route>
                                {/* <Route path="/auth/:username">
                  <Profile />
                </Route> */}
                                <Route path="/Kampanya-Detay/:campaignId">
                                    <CampaignDetail/>
                                </Route>
                                <Route path="/under-development">
                                    <UnderDevelopment/>
                                </Route>
                                <Route component={NotFound}/>
                            </Switch>
                        </Suspense>
                    </div>
                </Content>
            </Layout>
        </dataContext.Provider>
    );
}

export default App;



// WEBPACK FOOTER //
// ./src/app/App.js